import {formatDistanceToNow, parseISO} from "date-fns";
import {useTheme} from "../components/ThemeContext";
import {styled} from "@mui/material/styles";
import {TextField} from "@mui/material";

class Utils {
  // Backend returns LocalDateTime timestamps without a timezone designator
  // (e.g. "2026-04-17T21:03:00"). The server stores them in UTC, but
  // parseISO / new Date() interpret TZ-less ISO strings as local time, which
  // makes fresh posts appear to be in the future (e.g. "in about 7 hours"
  // for a user in PDT). Append "Z" when no timezone info is present so the
  // string is parsed as UTC.
  static ensureUtc(dateString) {
    if (typeof dateString !== "string") return dateString;
    // Already has a timezone designator: Z, +HH:MM, +HHMM, -HH:MM, -HHMM
    if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(dateString)) {
      return dateString;
    }
    return dateString + "Z";
  }

  static getFormattedTime(createdAt) {
    if (!createdAt || typeof createdAt !== "string") {
      return "Invalid date";
    }
    try {
      const parsedDate = parseISO(Utils.ensureUtc(createdAt));
      return formatDistanceToNow(parsedDate, {
        addSuffix: true,
      });
    } catch (error) {
      console.error("Error parsing date:", error);
      return "Invalid date";
    }
  }

  static abbreviateNumber(number) {
    if (typeof number !== "number") {
      return "Invalid number";
    }

    const abbreviations = [
      { value: 1e9, symbol: "B" },
      { value: 1e6, symbol: "M" },
      { value: 1e3, symbol: "k" },
    ];

    for (let i = 0; i < abbreviations.length; i++) {
      if (number >= abbreviations[i].value) {
        return (
          (number / abbreviations[i].value).toFixed(1) + abbreviations[i].symbol
        );
      }
    }

    return number.toString();
  }

  static stringAvatar = (name) => {
    const { theme } = useTheme();
    return {
      sx: {
        bgcolor: theme.palette.primary.main,
      },
      children: `${name[0]}`,
    };
  };

  // Add other utility methods here
}

export default Utils;

export const StyledTextField = styled(TextField)(({theme}) => ({
    marginBottom: 16,
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: theme.palette.primary.main,
        },
        "&:hover fieldset": {
            borderColor: theme.palette.primary.main,
        },
        "&.Mui-focused fieldset": {
            borderColor: theme.palette.primary.main,
        },
    },
    "& .MuiInputBase-input": {
        color: theme.palette.secondary.main,
        backgroundColor: `${theme.palette.background.default} !important`,
    },
    "& input:-webkit-autofill": {
        WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.default} inset !important`,
        WebkitTextFillColor: `${theme.palette.secondary.main} !important`,
    },
}));